module.exports = __webpack_public_path__ + "static/new-fba-routes-3630b0e63802f38ea602f4216c84f5e1.png";